// client/src/routes/_auth/set-password.$token.tsx — „Alegeți parola contului" · D-2985.
//
// The first password of an account the platform administrator opened (D-2984). The mail
// `account-created` links here with the reset flow's own sealed token, so the form is SCR-AUTH-005's
// in its first-password mode and the call is `POST /auth/password/reset`, unchanged. The token is
// the path's last segment and nothing follows it, which is what every helper that reads a reset
// token out of a link relies on. No session guard, for the reason the reset route has none.

import { createFileRoute } from '@tanstack/react-router';

import { ResetPasswordForm } from '@/features/auth/ResetPasswordForm';

export const Route = createFileRoute('/_auth/set-password/$token')({
  component: SetPasswordScreen,
});

function SetPasswordScreen() {
  const { token } = Route.useParams();
  return <ResetPasswordForm token={token} first />;
}
